<nav class="navbar navbar-expand">
    <a class="navbar-toggler d-none" href="javascript:void(0);" data-toggle="collapse" data-target="#navbarResponsive" aria-controls="navbarResponsive" aria-expanded="false" aria-label="Toggle navigation" (click)="toggleNavbar()">
        <fa-icon icon="bars"></fa-icon>
    </a>
    <div class="navbar-collapse collapse" id="navbarResponsive" [ngbCollapse]="isNavbarCollapsed" *ngIf="isAuthenticated()">
        <ul class="navbar-nav ml-auto">
            <li ngbDropdown class="nav-item dropdown pointer" display="dynamic" routerLinkActive="active" placement="bottom-right">
                <a class="nav-link dropdown-toggle" ngbDropdownToggle href="javascript:void(0);" id="account-menu">
                    <span fxHide="true" fxShow.gt-sm>{{getLogin()}}</span>
                </a>
                <ul class="dropdown-menu" ngbDropdownMenu aria-labelledby="account-menu">
                    <li>
                        <a class="dropdown-item" routerLinkActive="active"  (click)="router.navigateByUrl('settings/my-profile')">
                            <fa-icon icon="wrench" fixedWidth="true"></fa-icon>
                            <span class="ms-1" jhiTranslate="global.menu.account.settings">Settings</span>
                        </a>
                    </li>
                    <li>
                        <a class="dropdown-item"  (click)="changePassword()">
                            <fa-icon icon="lock" fixedWidth="true"></fa-icon>
                            <span class="ms-1" jhiTranslate="global.menu.account.password">Password</span>
                        </a>
                    </li>
                    <li class="dropdown-divider"></li>
                    <li>
                        <a class="dropdown-item" (click)="router.navigateByUrl('contact')">
                            <fa-icon icon="play" fixedWidth="true"></fa-icon>
                            <span class="ms-1" jhiTranslate="global.menu.help">How-to videos</span>
                        </a>
                    </li>
                    <li class="dropdown-divider"></li>
                    <li>
                        <a class="dropdown-item" (click)="logout()" id="logout">
                            <fa-icon icon="sign-out-alt" fixedWidth="true"></fa-icon>
                            <span class="ms-1" jhiTranslate="global.menu.account.logout">Sign out</span>
                        </a>
                    </li>
                </ul>
            </li>
            <li>
                <span *ngIf="avatarUrl">
                    <img [cache]="avatarUrl" class="profile-image rounded-circle" alt="Avatar">
                </span>
            </li>
        </ul>
    </div>
</nav>
